module.exports = __webpack_public_path__ + "assets/thumb.5dc3c33b7feebf48db5f8e690000109e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/thumb.png
// module id = 117
// module chunks = 0